import React from 'react';
import styles from './styles.scoped.css';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

export default function ErrorHandler({ title, message }) {
  return (
    <div className={styles['root']}>
      <div className={styles['wraper']}>
        <img alt="Server Error" src="assets/illu-server-error.svg" />
        <h1>{title}</h1>
        <span>{message}</span>
        <Link to="/">Kembali ke Dashboard</Link>
      </div>
    </div>
  );
}

ErrorHandler.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
};

